/** @format */
import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { CeeposPaymentService } from '../../../../common/service/ceepos-payment.service';
import { StudyRightExtensionWorkflowPaymentService } from '../study-right-extension-workflow-payment.service';

@Component({
    selector: 'app-study-right-extension-workflow-ceepos-confirmation',
    templateUrl: './study-right-extension-workflow-ceepos-confirmation.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class StudyRightExtensionWorkflowCeeposConfirmationComponent implements OnInit {
    private readonly ceeposPaymentService = inject(CeeposPaymentService);
    private readonly studyRightExtensionWorkflowPaymentService = inject(StudyRightExtensionWorkflowPaymentService);

    ngOnInit(): void {
        const paymentConfirmation = this.ceeposPaymentService.readCeeposResponseFromQueryParams();
        this.studyRightExtensionWorkflowPaymentService.completeCeeposPayment(paymentConfirmation);
    }
}
